import { useTranslation } from "react-i18next";
import PageHero from "@/components/layout/PageHero";
import { VisualSection, VisualCta } from "@/components/layout/visualLayout";
import SectionIntro from "@/components/layout/SectionIntro";
import PremiumSteps from "@/components/layout/PremiumSteps";
import Reveal from "@/components/common/Reveal";
import HoverGlow from "@/components/motion/HoverGlow";

export default function Investors() {
  const { t } = useTranslation();

  const steps = [1, 2, 3, 4, 5, 6, 7].map((n) => ({
    title: t(`investors.step${n}`),
    body: t(`investors.step${n}Body`),
  }));

  const principles = [
    { title: t("investors.how1Title"), body: t("investors.how1Body") },
    { title: t("investors.how2Title"), body: t("investors.how2Body") },
    { title: t("investors.how3Title"), body: t("investors.how3Body") },
  ];

  return (
    <div data-testid="page-investors">
      <PageHero
        eyebrow={t("investors.eyebrow")}
        title={t("investors.title")}
        subtitle={t("investors.lead")}
        testId="investors-hero"
      />

      <VisualSection testId="investors-process" divider>
        <SectionIntro eyebrow={t("investors.stepsEyebrow")} />
        <PremiumSteps steps={steps} testId="investors-steps" />
      </VisualSection>

      <VisualSection testId="investors-how" divider ambient="trust">
        <SectionIntro eyebrow={t("investors.howEyebrow")} title={t("investors.howTitle")} />
        <div className="grid md:grid-cols-3 gap-4">
          {principles.map(({ title, body }, i) => (
            <Reveal key={title} delay={i * 0.06}>
              <HoverGlow className="h-full">
                <article className="wit-card h-full group">
                  <h3 className="wit-heading-card">{title}</h3>
                  <p className="wit-body">{body}</p>
                </article>
              </HoverGlow>
            </Reveal>
          ))}
        </div>
      </VisualSection>

      <VisualCta to="/request-investor-call" label={t("investors.cta")} testId="investors-cta" />
    </div>
  );
}
